// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={216}
    height={135}
    viewBox="0 0 216 135"
    {...props}
  >
    <rect
      width={216}
      height={135}
      rx={6}
      fill="#F1F1F3"
    />
    <path
      d="M28.1852 21.4444C28.1852 19.0921 30.0921 17.1852 32.4444 17.1852H183.556C185.908 17.1852 187.815 19.0921 187.815 21.4444V112.556C187.815 114.908 185.908 116.815 183.556 116.815H32.4444C30.0921 116.815 28.1852 114.908 28.1852 112.556V21.4444Z"
      fill="white"
      stroke="#F9F9F9"
      strokeWidth={0.37037}
    />
    <rect
      x={131.704}
      y={22.1852}
      width={51.1111}
      height={88.8889}
      rx={4.44444}
      fill="#F9F9F9"
    />
    <rect
      x={33.1852}
      y={22.1852}
      width={94.0741}
      height={52.5926}
      rx={4.44444}
      fill="#F9F9F9"
    />
    <rect
      x={33.1852}
      y={79.2222}
      width={94.0741}
      height={31.8519}
      rx={4.44444}
      fill="#F9F9F9"
    />
    <circle
      cx={157.259}
      cy={41.074}
      r={12.963}
      fill="white"
    />
    <rect
      x={140.593}
      y={62.1852}
      width={34.0741}
      height={5.18518}
      rx={2.59259}
      fill="white"
    />
    <rect
      x={140.593}
      y={71.8148}
      width={19.2593}
      height={5.18518}
      rx={2.59259}
      fill="white"
    />
    <rect
      x={44.2963}
      y={35.5186}
      width={71.8519}
      height={5.18518}
      rx={2.59259}
      fill="white"
    />
    <rect
      x={44.2963}
      y={45.1482}
      width={41.7204}
      height={5.18518}
      rx={2.59259}
      fill="white"
    />
  </svg>
);
const SvgDefaultRecordingScreenshot = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgDefaultRecordingScreenshot;
